module.exports = __webpack_public_path__ + "img/register_bg_2.2fee0b50.png";